export default __webpack_public_path__ + "static/media/removeFromInterviewNes.a96849ac.svg";